import { AlgoliaApiQueryFilters } from 'algolia-api/types/AlgoliaApiQueryFilters';

import { getMainEverythingSearchRoutePath } from './getMainEverythingSearchRoutePath';
import { getMainGradProgramSearchRoutePath } from './getMainGradProgramSearchRoutePath';
import { getMainInternshipsSearchRoutePath } from './getMainInternshipsSearchRoutePath';
import { getMainJobsSearchRoutePath } from './getMainJobsSearchRoutePath';
import { getMainOrgSearchRoutePath } from './getMainOrgSearchRoutePath';
import { getMainVolopsSearchRoutePath } from './getMainVolopsSearchRoutePath';

type Args = {
  lang: UserLocale;
  filters: AlgoliaApiQueryFilters;
  q: string;
  radius: number | 'auto' | null;
};

export function getMainSearchRoutePathSwitch({
  lang,
  filters,
  q,
  radius,
}: Args) {
  switch (filters.type) {
    case undefined:
      return getMainEverythingSearchRoutePath({
        lang,
        q,
        radius,
        filters,
      });

    case 'ALL':
      throw new Error('ALL is not a valid listing type');

    case 'JOB':
      return getMainJobsSearchRoutePath({ lang, q, radius, filters });

    case 'INTERNSHIP':
      return getMainInternshipsSearchRoutePath({
        lang,
        q,
        radius,
        filters,
      });

    case 'VOLOP':
      return getMainVolopsSearchRoutePath({ lang, q, radius, filters });

    case 'ORG':
      return getMainOrgSearchRoutePath({ lang, q, radius, filters });

    case 'GRAD_PROGRAM':
      return getMainGradProgramSearchRoutePath({
        lang,
        q,
        radius,
        filters,
      });
  }
}
